/**
 * GEODOC
 *
 * Identificador civil principal por país.
 * O componente monta três campos: País, Documento e Número.
 *
 * - País reutiliza o catálogo Geography e mostra bandeira;
 * - Documento é somente visual e é derivado pelo backend a partir do país;
 * - Número aparece mascarado, mas o valor persistível sai normalizado no hidden
 *   `document_number`.
 *
 * O browser não escolhe `document_type`. Alterar o campo visual via DevTools
 * não muda o tipo usado pelo backend.
 */
export const geodoc = {
  legend: 'GeoDoc',
  isGrid: true,
  cols: 1,
  content: [
    {
      element: 'geodoc',
      id: 'tutorial-geodoc',
      required: true,
      defaultCountry: 'BR',
      values: {
        document_country: 'BR',
        document_number: '52998224725'
      },
      fields: {
        country: {
          name: 'document_country',
          label: 'País'
        },
        type: {
          label: 'Documento'
        },
        number: {
          name: 'document_number',
          label: 'Número'
        }
      }
    }
  ]
};

export default geodoc;
